<div class="header-container">
  <div class="header-inner">
    <div class="header-content">
      <!-- Logo -->
      <img
        routerLink="/dashboard"
        class="header-logo"
        src="assets/images/logo_avatipro.png"
        alt="Avati Pro"
      />

      <!-- Ações -->
      <ul class="header-actions list-none p-0 m-0 flex align-items-center">
        <!-- Novo registro -->
        <li>
          <div class="novo-registro-wrapper" (click)="toggleNovoRegistro($event)">
            <button pButton type="button"
              class="p-button-sm novo-registro-btn"
              icon="pi pi-plus"
              [label]="'header.buttons.novo_registro' | translate"
              iconPos="left">
              <i class="pi pi-chevron-down novo-registro-chevron"></i>
            </button>

            <div class="novo-registro-panel" *ngIf="showNovoRegistro"
                 (click)="$event.stopPropagation()">
              <div class="novo-registro-item" *ngFor="let atalho of atalhos"
                   (click)="navigateAtalho(atalho, $event)">
                <i [class]="atalho.icon" class="novo-registro-item-icon"></i>
                <span class="novo-registro-item-label">{{ atalho.labelKey | translate }}</span>
              </div>
            </div>
          </div>
        </li>

        <!-- Separador visual (desktop) -->
        <li class="header-separator hide-mobile"></li>

        <!-- Seletor de idioma (desktop) -->
        <li class="hide-mobile">
          <p-dropdown
            class="lang-dd lang-dd-flag-only"
            styleClass="lang-dropdown-circle"
            [options]="langs"
            optionLabel="label"
            optionValue="code"
            [(ngModel)]="currentCode"
            (onChange)="setLang($event.value)"
            [showClear]="false"
            [editable]="false"
            [filter]="false"
            appendTo="body"
            panelStyleClass="lang-dd-panel"
          >
            <ng-template let-opt pTemplate="item">
              <div class="lang-item">
                <img [src]="opt.flag" [alt]="opt.label" class="lang-flag" />
                <span class="lang-text">{{ opt.label }}</span>
              </div>
            </ng-template>

            <ng-template let-opt pTemplate="selectedItem">
              <div class="lang-selected-flag">
                <img [src]="(opt?.flag || currentFlag)" [alt]="opt?.label || currentLabel" class="lang-flag-only" />
              </div>
            </ng-template>
          </p-dropdown>
        </li>

        <!-- Toggle Dark/Light mode (desktop) -->
        <li class="hide-mobile">
          <button
            pButton
            type="button"
            class="p-button-rounded p-button-text theme-toggle-btn"
            [icon]="themeService.isDark() ? 'pi pi-sun' : 'pi pi-moon'"
            [pTooltip]="themeService.isDark() ? ('header.tooltips.modo_claro' | translate) : ('header.tooltips.modo_escuro' | translate)"
            tooltipPosition="bottom"
            (click)="themeService.toggle()"
          ></button>
        </li>

        <!-- Pedidos pendentes (mini shop) -->
        <li>
          <app-notificacoes-contrato></app-notificacoes-contrato>
        </li>

        <li>
          <div class="pedidos-pendentes-wrapper">
            <span class="p-overlay-badge">
              <button
                pButton
                type="button"
                [label]="'header.buttons.pedidos_pendentes' | translate"
                icon="pi pi-shopping-bag"
                class="p-button-sm header-pedidos-btn"
                (click)="togglePedidosPendentes($event)">
              </button>
              <span
                *ngIf="pedidosPendentesCount > 0"
                pBadge
                [value]="pedidosPendentesCount > 99 ? '99+' : pedidosPendentesCount.toString()"
                severity="danger"
                class="header-pedidos-badge">
              </span>
            </span>

            <div class="pedidos-pendentes-panel" *ngIf="showPedidosPendentes"
                 (click)="$event.stopPropagation()">
              <div class="pedidos-pendentes-header">
                <div class="pedidos-pendentes-header-icon">
                  <i class="pi pi-bell"></i>
                </div>
                <div class="pedidos-pendentes-header-texto">
                  <span class="pedidos-pendentes-header-titulo">
                    {{ 'header.pedidos_pendentes.titulo' | translate }}
                  </span>
                  <span class="pedidos-pendentes-header-subtitulo"
                        *ngIf="pedidosPendentesCount > 0">
                    {{ 'header.pedidos_pendentes.subtitulo' | translate }}
                  </span>
                </div>
                <span class="pedidos-pendentes-count" *ngIf="pedidosPendentesCount > 0">
                  {{ pedidosPendentesCount }}
                </span>
              </div>

              <div class="pedidos-pendentes-body">
                <ng-container *ngIf="pedidosPendentes.length > 0; else semPedidos">
                  <div class="pedidos-pendentes-item"
                       *ngFor="let p of pedidosPendentes"
                       [class.is-novo]="ehPedidoNovo(p.criadoEm)"
                       (click)="verPedidoPendente(p, $event)">
                    <div class="pedidos-pendentes-item-avatar">
                      <i class="pi pi-shopping-bag"></i>
                      <span class="pedidos-pendentes-item-dot"
                            *ngIf="ehPedidoNovo(p.criadoEm)"></span>
                    </div>

                    <div class="pedidos-pendentes-item-info">
                      <div class="pedidos-pendentes-item-linha-topo">
                        <span class="pedidos-pendentes-item-codigo">
                          {{ 'header.pedidos_pendentes.pedido' | translate }} #{{ p.codigo }}
                        </span>
                        <span class="pedidos-pendentes-item-novo-tag"
                              *ngIf="ehPedidoNovo(p.criadoEm)">
                          {{ 'header.pedidos_pendentes.novo' | translate }}
                        </span>
                      </div>

                      <div class="pedidos-pendentes-item-cliente">
                        <i class="pi pi-user"></i>
                        <span>{{ p.nomeCliente || ('header.pedidos_pendentes.cliente_anonimo' | translate) }}</span>
                      </div>

                      <div class="pedidos-pendentes-item-tags">
                        <span class="pedidos-pendentes-item-tempo" *ngIf="p.criadoEm">
                          <i class="pi pi-clock"></i>
                          <span>{{ formatarTempoRelativo(p.criadoEm) }}</span>
                        </span>
                        <span class="pedidos-pendentes-tipo-badge"
                              *ngIf="temTipoEntrega(p.tipoEntrega)"
                              [class]="'pedidos-pendentes-tipo-badge ' + getTipoEntregaClasse(p.tipoEntrega)">
                          <i [class]="getTipoEntregaIcone(p.tipoEntrega)"></i>
                          <span>{{ getTipoEntregaLabel(p.tipoEntrega) }}</span>
                        </span>
                      </div>
                    </div>

                    <i class="pi pi-arrow-right pedidos-pendentes-item-icon"></i>
                  </div>
                </ng-container>
                <ng-template #semPedidos>
                  <div class="pedidos-pendentes-vazio">
                    <div class="pedidos-pendentes-vazio-circulo">
                      <i class="pi pi-check"></i>
                    </div>
                    <span class="pedidos-pendentes-vazio-titulo">
                      {{ 'header.pedidos_pendentes.vazio' | translate }}
                    </span>
                    <span class="pedidos-pendentes-vazio-subtitulo">
                      {{ 'header.pedidos_pendentes.vazio_subtitulo' | translate }}
                    </span>
                  </div>
                </ng-template>
              </div>

              <div class="pedidos-pendentes-footer">
                <button pButton type="button"
                        class="p-button-sm p-button-text"
                        [label]="'header.pedidos_pendentes.ver_todos' | translate"
                        icon="pi pi-list"
                        (click)="verTodosPedidosPendentes($event)">
                </button>
              </div>
            </div>
          </div>
        </li>

        <!-- Carrinho -->
        <li>
          <span class="p-overlay-badge">
            <button
              pButton
              type="button"
              [label]="'header.buttons.carrinho' | translate"
              icon="pi pi-shopping-cart"
              class="p-button-sm header-cart-btn"
              (click)="goToVendas()"
            ></button>
            <span pBadge [value]="cartCount" class="header-cart-badge"></span>
          </span>
        </li>

        <!-- Separador visual (desktop) -->
        <li class="header-separator hide-mobile"></li>

        <!-- Sair (desktop) -->
        <li class="hide-mobile">
          <button
            pButton
            type="button"
            [label]="'header.buttons.sair' | translate"
            icon="pi pi-sign-out"
            class="p-button-sm header-sair-btn"
            (click)="logout()"
          ></button>
        </li>

        <!-- Hamburger (mobile) -->
        <li class="show-mobile">
          <button
            pButton
            type="button"
            class="p-button-rounded p-button-text mobile-menu-toggle"
            icon="pi pi-bars"
            (click)="toggleMobileMenu()"
          ></button>
        </li>
      </ul>
    </div>
  </div>
</div>

<!-- Overlay do menu mobile -->
<div class="mobile-overlay" *ngIf="showMobileMenu" (click)="closeMobileMenu()"></div>

<!-- Sidebar mobile -->
<div class="mobile-sidebar" [class.open]="showMobileMenu">
  <!-- FIX-S3: Header com logo em vez de texto genérico -->
  <div class="mobile-sidebar-header">
    <img
      src="assets/images/logo_avatipro.png"
      alt="Avati Pro"
      class="mobile-sidebar-header-logo"
    />
    <button
      pButton
      type="button"
      class="p-button-rounded p-button-text mobile-sidebar-close"
      icon="pi pi-times"
      (click)="closeMobileMenu()"
    ></button>
  </div>

  <!-- FIX-S2: Seção de identidade (nome da empresa) -->
  <div class="mobile-sidebar-identity">
    <i class="pi pi-building" style="font-size: 20px; color: #64748b;"></i>
    <span class="mobile-sidebar-app-name">Avati Pro</span>
  </div>

  <div class="mobile-sidebar-content">
    <!-- Idioma -->
    <div class="mobile-menu-item">
      <i class="pi pi-globe mobile-menu-icon"></i>
      <span class="mobile-menu-label">{{ 'header.idioma' | translate }}</span>
      <!-- FIX-S1: Opções empilhadas verticalmente -->
      <div class="mobile-lang-options">
        <div
          *ngFor="let lang of langs"
          class="mobile-lang-option"
          [class.active]="currentCode === lang.code"
          (click)="setLang(lang.code)"
        >
          <img [src]="lang.flag" [alt]="lang.label" class="mobile-lang-flag" />
          <span>{{ lang.label }}</span>
        </div>
      </div>
    </div>

    <!-- FIX-S4: Dark mode com toggle switch -->
    <div class="mobile-menu-item" (click)="themeService.toggle()">
      <div class="mobile-menu-item-toggle">
        <div class="mobile-menu-item-left">
          <i [class]="themeService.isDark() ? 'pi pi-sun' : 'pi pi-moon'" class="mobile-menu-icon"></i>
          <span class="mobile-menu-label">
            {{ themeService.isDark() ? ('header.tooltips.modo_claro' | translate) : ('header.tooltips.modo_escuro' | translate) }}
          </span>
        </div>
        <p-inputSwitch
          [ngModel]="themeService.isDark()"
          (click)="$event.stopPropagation()"
          (onChange)="themeService.toggle()"
        ></p-inputSwitch>
      </div>
    </div>

    <!-- Separador -->
    <div class="mobile-menu-divider"></div>

    <!-- Sair -->
    <div class="mobile-menu-item mobile-menu-item--danger" (click)="mobileLogout()">
      <i class="pi pi-sign-out mobile-menu-icon"></i>
      <span class="mobile-menu-label">{{ 'header.buttons.sair' | translate }}</span>
    </div>
  </div>

  <!-- FIX-S2: Rodapé com versão -->
  <div class="mobile-sidebar-footer">
    <span class="mobile-sidebar-version">{{ appVersion }}</span>
  </div>
</div>
